import React from 'react';
import { DialogTitle, DialogContent, Typography } from '@mui/material';
import { SimpleModal } from 'components/Modal';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import styled from 'styled-components';

const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 16px 24px;
  
  .MuiButton-root {
    width: 100%;
  }
`;

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ open, onClose }) => {
  return (
    <SimpleModal isOpen={open} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        Thank you for your feedback!
      </DialogTitle>
      <DialogContent>
        <Typography align="center" gutterBottom>
          We value your insights so we can continually improve how we make great temping and hiring connections for you. Much appreciated!
        </Typography>
      </DialogContent>
      <ModalButtonContainer>
        <StyledButton
          variant="contained"
          color="primary"
          onClick={onClose}
          autoFocus
        >
          OK
        </StyledButton>
      </ModalButtonContainer>
    </SimpleModal>
  );
};

export default SuccessModal; 